<template>
  <div style="width: 100%">
    <h1>Consultas</h1>


    <v-row v-if="tableAppoinments === true && editSectionAppoinment === false">
      <v-col sm="4">
        <user-search item-text="email" search-by="email" @changeUser="filterDataIdUser"></user-search>
      </v-col>
    </v-row>
    <v-row v-if="tableAppoinments === true && editSectionAppoinment === false">
      <v-col>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="post"
            multi-sort
            :sort-by="['updated_at']"
            :sort-desc="[true]"
            :items-per-page="20"
            class="elevation-1"
          >
          <template v-slot:item.date="{ item }">
            <span class="text-center" :inner-html.prop="item.date | formatDate"></span>
          </template>
          <template v-slot:item.created_at="{ item }">
            <span class="text-center" :inner-html.prop="item.created_at | formatDate"></span>
          </template>
          <template v-slot:item.updated_at="{ item }">
            <span class="text-center" :inner-html.prop="item.updated_at | formatDate"></span>
          </template>
          <template v-slot:item.usuario="{ item }">
            {{item.user.display_name}} <br v-if="item.user.display_name"/> {{item.user.email}}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn small class="ma-2" color="primary"
              @click="editAppoinment(item.id), listPayment(item.id)">
              Editar
              <v-icon right small>mdi-pencil</v-icon>
            </v-btn>
          </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="tableAppoinments === false && editSectionAppoinment === true" class="card-payment">
      <v-col >
        <v-card class="card-100">
          <v-card-title class="ma-2" style="font-family: Avenir">
            Editar consulta
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid"
                    ref="form"
                    :lazy-validation="lazy"
                    class="ma-2">
              <v-row>
                <v-col class="" sm="8">
                  <label>Fecha de la consulta</label>
                  <br/>
                  <v-datetime-picker v-model="picker">
                    <template slot="actions" slot-scope="{ parent }">
                      <v-btn text color="primary darken-1" @click="parent.okHandler">OK</v-btn>
                    </template>
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-timer</v-icon>
                    </template>
                  </v-datetime-picker>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="" sm="8">
                  <label>Estado de la consulta</label>
                  <br/>
                  <v-select
                      v-model="selectValueConsultation"
                      :items="items"
                      :rules="[v => !!v || 'Seleccione un motivo']"
                      item-text="text"
                      item-value="value"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col sm="8" class="mb-0 pb-0">
                  <label>Monto US$</label>
                  <br/>
                  <v-text-field
                      label=""
                      type="text"
                      required
                      onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"
                      v-model="mount"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="tablePayment === true" class="pt-0 mt-0">
                <v-col sm="12" class="pt-0 mt-0">
                  <dt style="font-size: 16px;">Pendiente de pago</dt>
                  <dl>US$ {{ amountToPay }}</dl>
                </v-col>
              </v-row>
              <v-btn class="mt-3 mb-4" color="primary" @click="setCurrentUser()">Ir a usuario</v-btn>

              <v-row v-if="tablePayment === true">
                <v-col>
                  <label style="font-size: 18px;" class="mb-5">Últimos pagos</label>
                  <br/>
                  <v-simple-table>
                    <template>
                      <thead>
                      <tr>
                        <th class="">Último pago</th>
                        <th class="">Tipo de pago</th>
                        <th class="">Método de pago</th>
                        <th class="">Monto</th>
                        <th class="">Estado</th>
                        <th class=""></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="dataPayment in postPayment" :key="dataPayment.id">
                        <td>{{ dataPayment.created_at.slice(0, 10) }}</td>
                        <td v-if="dataPayment.payment_type_id === 2">Pago total</td>
                        <td v-if="dataPayment.payment_type_id === 1">Pago parcial</td>
                        <td v-if="dataPayment.payment_online && (dataPayment.payment_online.payment_provider === 'PAYPAL' || dataPayment.payment_online.payment_provider === 'CULQI')">
                          {{dataPayment.payment_online.payment_provider}}
                        </td>
                        <td v-else>
                          {{ dataPayment.payment_method.name }}
                          <a class="text-decoration-none" v-if="dataPayment.payment_method.name === 'Transferencia'"
                             target="_blank" :href="urlTransfer"
                             download="fileTransfer">
                            <v-icon color="primary">mdi-file-find</v-icon>
                          </a>
                        </td>


                        <td>US$ {{ dataPayment.amount }}</td>

                        <td v-if="dataPayment.rejected === 0 && dataPayment.confirmed === 0">Pendiente de confirmación
                        </td>
                        <td v-if="dataPayment.rejected === 1">Rechazado</td>
                        <td v-if="dataPayment.confirmed  === 1 && dataPayment.rejected !== 1">Confirmado</td>
                        <td>
                          <v-btn small class="ma-2" color="primary"
                                 v-if="dataPayment.payment_method.name === 'Transferencia'"
                                 @click="editModal(dataPayment.id)">
                            Editar
                            <v-icon right small>mdi-pencil</v-icon>
                          </v-btn>
                        </td>

                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>


              <v-row class="btn-size-auto">
                <v-col sm="12" class="text-center">
                  <v-btn class="mr-4 mt-4" color="primary" dark outlined small
                         @click="mount=0, tableAppoinments=true, editSectionAppoinment=false">
                    Volver
                  </v-btn>
                  <v-btn class="primary mr-4 mt-4" small :disabled="!valid" @click="updateConsultation(picker)">
                    Guardar cambios
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <template>
            <v-row>
              <v-dialog v-model="dialogEditPayment" persistent max-width="450px">
                <v-card class="modal-payment">
                  <v-card-title>
                    <h3 class="text-center w100" style="width: 100%">Editar pago</h3>
                  </v-card-title>
                  <v-card-text class="pb-0">
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <label>Monto US$</label>
                          <v-text-field
                              placeholder=""
                              type="text"
                              onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"
                              class="w100"
                              required
                              v-model="amountPayment">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <label>Estado</label>
                          <v-select
                              v-model="paymentRejected"
                              :items="itemsRejected"
                              item-text="text"
                              item-value="value"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions class="pb-10 btn-size-auto">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined small @click="dialogEditPayment = false">Cancelar</v-btn>
                    <!--<v-btn color="primary" :disabled="!paymentRejected" small @click="editPaymentSingle">Editar</v-btn>-->
                    <v-btn color="primary" small @click="editPaymentSingle">Guardar</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </div>

</template>

<script>

import {mapActions, mapState} from "vuex";
import UserSearch from "@/components/UserSearch";
import $day from "dayjs"
import router from "@/router";

export default {
  name: 'Appointments',
  components: {UserSearch},
  data() {
    return {
      headers: [
        { text: 'Usuario', value: 'usuario' },
        { text: 'Motivo', value: 'reason' },
        { text: 'F. Creación', value: 'created_at' },
        { text: 'Ú. Actualización', value: 'updated_at' },
        { text: 'F. Programada', value: 'date' },
        { text: 'Estado', value: 'state.description' },
        { text: 'Acción', value: 'actions', sortable: false },
      ],
      picker: new Date(),
      tableAppoinments: true,
      editSectionAppoinment: false,
      valid: false,
      lazy: false,
      selectValueConsultation: {text: 'Pendiente de confirmación', value: 1},
      items: [
        {text: 'Pendiente de confirmación', value: 1},
        {text: 'Pendiente de pago', value: 2},
        {text: 'Confirmado', value: 3},
        {text: 'Realizado', value: 4},
        {text: 'Cancelado', value: 5}
      ],
      tablePayment: false,
      urlTransfer: null,
      idConsultation: '',
      idState: 0,
      ddmmyy: '',
      mount: 0,
      needToPay: 0,
      totalToPay: 0,
      dialogEditPayment: false,
      arrayPayment: [],
      idPayment: '',
      paymentRejected: {text: 'Confirmado', value: 0},
      itemsRejected: [
        {text: 'Confirmado', value: 0},
        {text: 'Rechazado', value: 1}
      ],
      amountPayment: 0,
      request: {}
    }
  },
  filters: {
    formatDate: function (value) {
      let date = $day(value).format('YYYY-MM-DD h:mm')
      date = date.split(' ').join('<br/>')
      return date
    }
  },
  computed: {
    ...mapState('appoinments', [
      'post',
      'postSingle',
      'postPayment'
    ]),
    ...mapState('user', [
      'currentUser'
    ]),
    amountToPay() {
      return this.mount - this.totalToPay
    },
  },
  methods: {
    ...mapActions('appoinments', [
      'fetchConsul',
      'fetchConsultationSingle',
      'fetchPayment',
      'updateDataConsultation',
      'fetchConsulUserId',
      'updatePaymentId'
    ]),
    ...mapActions("user", [
      "updateCurrentUser",
    ]),
    ...mapActions(['loaderChange']),
    filterDataIdUser() {

      this.loaderChange(true)
      let request = {
        id: this.currentUser
      }
      this.fetchConsulUserId(request).finally(() => {
        this.loaderChange(false)
      })

    },
    editAppoinment(id) {
      this.loaderChange(true)
      this.tableAppoinments = false
      this.editSectionAppoinment = true
      this.idConsultation = id
      let request = {
        id: id
      }

      this.fetchConsultationSingle(request).finally(() => {

        this.picker = new Date(this.postSingle.date)
        this.selectValueConsultation = this.postSingle.consultation_state_id
        this.mount = this.postSingle.price
        this.loaderChange(false)
      })
    },
    listPayment(id) {
      this.loaderChange(true)

      this.idConsultation = id
      let request = {
        id: id
      }

      this.fetchPayment(request).finally(() => {
        if (this.postPayment.length) {
          for (let i in this.postPayment) {
            if (this.postPayment[i].payment_transfer !== null) {
              this.urlTransfer = this.postPayment[i].payment_transfer.file_url
            }
          }

          this.tablePayment = true

          for (let i in this.postPayment) {
            if (this.postPayment[i].rejected !== 1) {
              this.totalToPay += this.postPayment[i].amount
            }
          }
          this.loaderChange(false)
        } else {
          this.tablePayment = false
        }
      })
    },
    updateConsultation(day) {
      this.loaderChange(true)

      this.idState = this.selectValueConsultation

      let request = {
        data: {
          'price': this.mount || 0,
          'date': $day(day).format('YYYY-MM-DD HH:mm:ss'),
          'consultation_state_id': this.idState
        },
        id: this.idConsultation
      }
      this.updateDataConsultation(request).finally(() => {
        this.tableAppoinments = true
        this.editSectionAppoinment = false
        //location.reload()
        this.loaderChange(false)
      })
    },
    editModal(id) {
      this.dialogEditPayment = true
      this.arrayPayment = this.postPayment.find(x => x.id === id);
      this.idPayment = id
      this.amountPayment = this.arrayPayment.amount
    },
    editPaymentSingle() {
      this.loaderChange(true)
      this.dialogEditPayment = false

      if (this.paymentRejected === 0) {
        this.request = {
          id: this.idConsultation,
          pay: this.idPayment,
          data: {
            'amount': this.amountPayment,
            'rejected': this.paymentRejected,
            'confirmed': 1,
          }
        }
        this.selectValueConsultation = 3
      } else {
        this.request = {
          id: this.idConsultation,
          pay: this.idPayment,
          data: {
            'amount': this.amountPayment,
            'rejected': this.paymentRejected,
            'confirmed': 0
          }
        }
        this.selectValueConsultation = 2
      }

      this.updatePaymentId(this.request).finally(() => {
        //Mostrar la tabla de consultas
        /*this.tableAppoinments = true
        this.editSectionAppoinment = false*/
        this.dialogEditPayment = false
        //location.reload()
        this.loaderChange(false)
      })
    },
    setCurrentUser() {
      console.log(this.postSingle.user_id)
      this.updateCurrentUser(this.postSingle.user_id)
      localStorage.setItem('showThisUser', true)
      router.push({name: 'Profile'})
    }
  },
  mounted() {
    this.loaderChange(true)
    this.fetchConsul().finally(() => {
      this.loaderChange(false)
    })

    /*if (!localStorage.getItem('token')) {
      sessionStorage.setItem('url', window.location.href);
    }*/
  }
}
</script>
<style lang="scss" scoped>
.card-payment {
  width: 100%;
  max-width: 890px;
  min-width: 350px;
}

.table-ctn {
  padding: 20px;

  .highlight {
    color: #29678B;
    font-weight: 600;
  }

  ::v-deep thead {
    font-size: 16px;

    th {
      border-bottom: 2px solid #43A4BB !important;
      font-size: 16px !important;
      font-weight: 800;

      &:nth-child(1) {
        width: 25%;
      }

      &:nth-child(2) {
        width: 40%;
      }

      &:nth-child(3) {
        width: 36%;
      }
    }

    span {
      font-size: 16px;
      font-weight: 600;
      color: #656565;
    }
  }

  ::v-deep tbody {
    &:before {
      content: '';
      display: block;
      padding-top: 8px;
    }

    td {
      font-size: 16px;
      font-weight: 200;
      color: #656565;
      border-bottom: none !important;
    }
  }
}

::v-deep .v-btn {
  text-transform: unset;
  font-family: "Avenir";
  letter-spacing: normal;
  font-size: 14px;
  height: 40px;
  width: 160px;
  border-radius: 7px;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

::v-deep .v-input {
  width: 250px;
  .v-messages__message {
    padding-top: 3px;
  }
  &.v-input--is-disabled {
    .v-input__slot::before {
      display: none;
    }

    .v-input__append-inner {
      display: none;
    }
  }

  .v-input__slot {
    margin-bottom: 0;

    .v-text-field__slot input {
      color: #656565;
    }
  }
}

.table-styled {
  color: #656565;

  th {
    font-weight: 800;
    font-size: 14px !important;

    &:last-child {
      text-align: center !important;
    }
  }
}

.modal-payment {
  ::v-deep .v-input {
    width: 100%;
    color: #656565;
  }
}
.card-100 {
  width: 100%;
}
::v-deep th:nth-child(2){
  width: 150px;
}
::v-deep th:nth-child(3){
  width: 150px;
}
::v-deep th:nth-child(5){
  text-align: center !important;
}
::v-deep .v-data-footer {
  .v-btn {
    width: auto;
  }
}
::v-deep th.text-start.sortable{
  width: 200px;
}
::v-deep th {
  &:last-child span{
    display: inline-block;
    text-align: center;
    width: 100%;
  }
}
::v-deep table .v-btn {
  width: 130px;
}
</style>
